import { render, staticRenderFns } from "./EditQueryAnswerType.vue?vue&type=template&id=5a27f314"
import script from "./EditQueryAnswerType.vue?vue&type=script&lang=js"
export * from "./EditQueryAnswerType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports